import SeatsSelect from './SeatsSelect';
export default SeatsSelect;